import { DatePicker, Form, Input, Row, Col, Select, InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import {
  MailOutlined,
  FileTextOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { validatePhoneNumber } from "utils/validator";
const { Option } = Select;
///
export default function EmployeeForm({ form, onSubmit }) {
  const { t } = useTranslation();
  const functions = [
    {
      clé: "Éducatrice",
      valeur: "employees.crud.form.label.function.val.Éducatrice",
    },
    {
      clé: "Femme de ménage",
      valeur: "employees.crud.form.label.function.val.FemmeDeMenage",
    },
    {
      clé: "Directeur",
      valeur: "employees.crud.form.label.function.val.Directeur",
    },
    {
      clé: "Chef de service",
      valeur: "employees.crud.form.label.function.val.ChefDeService",
    },
    { clé: "Gérant", valeur: "employees.crud.form.label.function.val.Gérant" },
    {
      clé: "Responsable pédagogique",
      valeur: "employees.crud.form.label.function.val.ResponsablePedagogique",
    },
    {
      clé: "Location diplôme",
      valeur: "employees.crud.form.label.function.val.LocationDiplome",
    },
    {
      clé: "Cuisinier",
      valeur: "employees.crud.form.label.function.val.Cuisinier",
    },
    {
      clé: "Chauffeur",
      valeur: "employees.crud.form.label.function.val.Chauffeur",
    },
    {
      clé: "Assistante",
      valeur: "employees.crud.form.label.function.val.Assistante",
    },
  ];
  return (
    <Form
      layout="vertical"
      name="employee_form"
      id="employee_form"
      form={form}
      onFinish={onSubmit}
      style={{
        maxWidth: 600,
        margin: "0 auto",
        marginTop: "30px",
      }}
    >
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.lastName")}
            name="lastName"
            rules={[
              {
                required: true,
                message: t("employees.crud.form.error.label.required.lastName"),
              },
            ]}
          >
            <Input
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
            />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.firstName")}
            name="firstName"
            rules={[
              {
                required: true,
                message: t(
                  "employees.crud.form.error.label.required.firstName"
                ),
              },
            ]}
          >
            <Input
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.entryDate")}
            name="entryDate"
            rules={[
              {
                required: true,
                message: t(
                  "employees.crud.form.error.label.required.entryDate"
                ),
              },
            ]}
          >
            <DatePicker
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              style={{ width: "100%" }}
              allowClear
              className="custom-input"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.exitDate")}
            name="exitDate"
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  // Validation optionnelle mais cohérence des dates
                  if (
                    value &&
                    getFieldValue("entryDate") &&
                    value < getFieldValue("entryDate")
                  ) {
                    return Promise.reject(
                      t("employees.crud.form.error.date.invalidOrder")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              className="custom-input"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.phoneNumber")}
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: t(
                  "employees.crud.form.error.label.required.phoneNumber"
                ),
              },
              { validator: validatePhoneNumber(t) },
            ]}
          >
            <Input
              prefix={<FileTextOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.socialSecurityNumber")}
            name="socialSecurityNumber"
            rules={[
              {
                required: true,
                message: t(
                  "employees.crud.form.error.label.required.socialSecurityNumber"
                ),
              },
              {
                pattern: /^[1-9]\d{12}$/,
                message: t(
                  "employees.crud.form.error.label.invalid.socialSecurityNumber"
                ),
              },
            ]}
          >
            <Input
              prefix={<IdcardOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
              maxLength={13}
              placeholder="13 chiffres, sans 00 en tête"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.email")}
            name="email"
            rules={[
              {
                required: true,
                message: t("employees.crud.form.error.label.required.email"),
              },
            ]}
          >
            <Input
              prefix={<MailOutlined style={{ color: "#f3db56" }} />}
              className="custom-input"
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={t("employees.crud.form.label.salary")}
            name="salary"
            rules={[
              {
                required: true,
                message: t("employees.crud.form.error.label.required.salary"),
              },
              {
                validator: (_, value) => {
                  if (value === undefined || value === null || value === "") {
                    return Promise.resolve();
                  }
                  const numericValue = Number(value);
                  if (!Number.isFinite(numericValue) || numericValue <= 1000) {
                    return Promise.reject(
                      t("employees.crud.form.error.label.min.salary")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputNumber
              prefix={<IdcardOutlined style={{ color: "#f3db56" }} />}
              style={{ width: "100%" }}
              className="custom-input"
              min={1001}
              stringMode
              controls={false}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24}>
          <Form.Item
            label={t("employees.crud.form.label.function")}
            name="function"
            rules={[
              {
                required: true,
                message: t("employees.crud.form.error.label.required.function"),
              },
            ]}
          >
            <Select
              placeholder={t(
                "employees.crud.form.error.label.required.placeholderfunction"
              )}
              className="custom-input"
            >
              {functions.map((func) => (
                <Option key={func.clé} value={func.clé}>
                  {t(func.valeur)}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item
            label={t("employees.crud.form.label.address")}
            name="address"
            rules={[
              {
                required: true,
                message: t("employees.crud.form.error.label.required.address"),
              },
            ]}
          >
            <Input.TextArea rows={4} className="custom-input" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
